<a href="#skip" class="back-top" aria-label="Back to top of the page" [@appearInOut]="animationState" (click)="scrollTop($event)">
    <em class="fa fa-chevron-up fa-lg"></em>
    <span class="sr-only">Back to top</span>
</a>